import { OuiSelectOption } from 'omnium-ui/form-field';
import { Observable } from 'rxjs';
import { inOperator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getObjectifBuilders(optionsObjectifs$: Observable<OuiSelectOption<string>[]>): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'OBJECTIFS',
      'OBJECTIFS_INV',
      'objectifDefinis.some.objectifReferenceCode',
      inOperator,
      'SelectMultiple',
      optionsObjectifs$
    ),
  ];
}
